import React, {Component} from 'react';
import {Card, Grid, Button} from 'semantic-ui-react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Actions} from '../../../common/actions';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import Filters from './filters';
import SearchButton from './searchButton';
import ExportButton from './exportButton';
import TableLostSalesReport from './table';
import PartLostSalesDetail from './lostSalesDetail';

class LostSalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'isDealerAdmin': hasAccessPermission(props.permissions, resources.DealerLostSalesReport, scopes.PartialSee),
    };
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.DealerLostSalesReport, scopes.See) &&
    !hasAccessPermission(this.props.permissions, resources.DealerLostSalesReport, scopes.PartialSee) &&
    !hasAccessPermission(this.props.permissions, resources.DealerLostSalesReport, scopes.LimitedSee)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.getUsers();
    this.props.fetchDealers('importers');
    this.props.getAllAgencies();
    this.props.clearLostSalesReportDetail();
    this.clearFilters();
  }

  clearFilters() {
    const {isDealerAdmin} = this.state;
    const {isUserFromTDE, dealerId, dealerAgency} = this.props;

    this.props.updateLostSalesReportFilters({
      'initialDate': moment().startOf('month').format(noTimeZoneShortISODate),
      'finalDate': moment().format(noTimeZoneShortISODate),
      'dealer': isUserFromTDE ? '' : dealerId,
      'agency': (isUserFromTDE || isDealerAdmin) ? '' : dealerAgency,
      'user': '',
      'reason': '',
      'partCode': '',
    });
  }

  handleClearClick() {
    this.props.clearLostSalesReportDetail();
    this.clearFilters();
  }

  handleDownloadClick() {
    this.props.fetchDownloadLostSalesReportDetail();
  }

  render() {
    const {loadingAgencies, loadingLostSalesDetail, downloading} = this.props;

    return (
      <div className='dealer-lost-sales'>
        <Card raised fluid className='lost-sales-header'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='8' textAlign='left'>
                <h2>Reporte de Ventas Perdidas</h2>
              </Grid.Column>
              <Grid.Column width='8' textAlign='right'>
                <Button secondary
                  content='LIMPIAR'
                  disabled={loadingAgencies || loadingLostSalesDetail || downloading}
                  onClick={this.handleClearClick}
                />
                <ExportButton />
                <SearchButton />
              </Grid.Column>
            </Grid.Row>
            <Filters />
          </Grid>
        </Card>
        <Card raised fluid>
          <Grid textAlign='left'>
            <Grid.Row columns={1}>
              <Grid.Column>
                <TableLostSalesReport />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <PartLostSalesDetail />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'isUserFromTDE': state.session.isUserFromTDE,
    'dealerId': state.session.dealerId,
    'dealerAgency': state.session.dealerAgency,
    'loadingLostSalesDetail': state.lostSalesReportDetail.loading,
    'loadingAgencies': state.dealer.loading || state.dealer.loadingAgencies,
    'permissions': state.session.permissions,
    'downloading': state.lostSalesReportDetail.downloading,
  };
};

const {
  getUsers,
  fetchDealers,
  getAllAgencies,
  fetchLostSalesReportDetail,
  clearLostSalesReportDetail,
  updateLostSalesReportFilters,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  getUsers,
  fetchDealers,
  getAllAgencies,
  fetchLostSalesReportDetail,
  clearLostSalesReportDetail,
  updateLostSalesReportFilters,
  navigateTo,
})(LostSalesReport);
